<template>
    <div id="index">
        <el-scrollbar :class="isCollapse?'menu_hide rightSide':'rightSide'">
            <el-main>
                <el-breadcrumb separator-class="el-icon-arrow-right" class="mainBread">
                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('HomePage')}}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/' }">{{ $t('systemConfiguration') }}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ $t('Laboratory') }}</el-breadcrumb-item>
                </el-breadcrumb>
                <el-form ref="formselect" :model="formselect" label-width="80px" class="queryform_div">
<!--                    <el-form-item label="城市">-->
                    <el-form-item :label="$t('City')">
                        <el-select v-model="formselect.cityId" @change="getFac" :placeholder="$t('el.select.placeholder')" filterable
                                   class="queryform">
                            <el-option v-for="(item,index) in area" :key="'inx1'+index" :value="item.value"
                                       :label="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Campus')">
                        <el-select v-model="formselect.factoryId" @change="getBuild" :placeholder="$t('el.select.placeholder')" filterable
                                   class="queryform">
                            <el-option v-for="(item,index) in facList" :key="'inx2'+index" :value="item.value"
                                       :label="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Building')">
                        <el-select v-model="formselect.buildingId" @change="getLab" :placeholder="$t('el.select.placeholder')" filterable
                                   class="queryform">
                            <el-option v-for="(item,index) in building" :key="'inx3'+index" :value="item.value"
                                       :label="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Lab')">
                        <el-select v-model="formselect.LabId" :placeholder="$t('el.select.placeholder')" filterable class="queryform">
                            <el-option v-for="(item,index) in labList" :key="'inx4'+index" :value="item.value"
                                       :label="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary">{{ $t('Query') }}</el-button>
                        <el-button>{{ $t('Cancel') }}</el-button>
                    </el-form-item>
                </el-form>
                <template>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="dialogAddPrice = true" style="margin-bottom:10px;">
                      {{ $t('Add') }}</el-button>

                    <el-table ref="multipleTable"
                              :data="tableData1"
                              border
                              stripe
                              style="width:100%;min-height:200px;">
                        <el-table-column fixed="left"
                                         type="index"
                                         :label="$t('SN')"
                                         width="50">
                        </el-table-column>
                        <el-table-column prop="lab"
                                         :label="$t('Lab')"
                                         width="150px">
                        </el-table-column>
                        <el-table-column prop="year"
                                         :label="$t('Year')"
                                         width="80px">
                        </el-table-column>
                        <el-table-column prop="Jan"
                                         :label="$t('Jan')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="Feb"
                                         :label="$t('Feb')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="Mar"
                                         :label="$t('Mar')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="Apr"
                                         :label="$t('Apr')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="May"
                                         :label="$t('May')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="June"
                                         :label="$t('Jun')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="July"
                                         :label="$t('Jul')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="Aug"
                                         :label="$t('Aug')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="Sept"
                                         :label="$t('Sep')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="Oct"
                                         :label="$t('Oct')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="Nov"
                                         :label="$t('Nov')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="Dec"
                                         :label="$t('Dec')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column fixed="right"
                                         label="操作"
                                         width="150">
                            <template slot-scope="scope">
                                <el-button @click="dialogEditEquipment=true" type="primary" size="small">{{ $t('Edit') }}</el-button>
                                <template>
                                    <el-popconfirm placement="top"
                                                   :confirmButtonText="$t('Delete')"
                                                   :cancelButtonText="$t('Cancel')"
                                                   icon="el-icon-info"
                                                   iconColor="red"
                                                   :title="$t('DeleteConfirm')">
                                        <el-button size="mini" type="danger" slot="reference" style=" margin-left: 10px;">
                                          {{ $t('Delete') }}</el-button>
                                    </el-popconfirm>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>

            </el-main>
        </el-scrollbar>
        <el-dialog :title="$t('Add')" :visible.sync="dialogAddPrice" width="80%" top="10vh">
            <el-form ref="Priceform" :model="Priceform" label-width="150px">
                <el-row :gutter="24">

                    <el-col :span="12">
                        <el-form-item :label="$t('Country')">
                            <el-select :placeholder="$t('el.select.placeholder')" style="width: 100%;" v-model="Priceform.country">
                                <el-option v-for="item in country"
                                           :key="item.value"
                                           :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('City')">
                            <el-select :placeholder="$t('el.select.placeholder')" style="width: 100%;" v-model="Priceform.city">
                                <el-option v-for="item in city"
                                           :key="item.value"
                                           :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('Campus')">
                            <el-select :placeholder="$t('el.select.placeholder')" style="width: 100%;" v-model="Priceform.pack">
                                <el-option v-for="item in pack"
                                           :key="item.value"
                                           :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('Building')">
                            <el-select :placeholder="$t('el.select.placeholder')" style="width: 100%;" v-model="Priceform.buiilding">
                                <el-option v-for="item in buiilding"
                                           :key="item.value"
                                           :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('Lab')" style="width:100%">
                            <el-select :placeholder="$t('el.select.placeholder')" style="width: 100%;" v-model="Priceform.lab">
                                <el-option v-for="item in lab"
                                           :key="item.value"
                                           :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('Year')">
                            <el-date-picker v-model="Priceform.year"
                                            type="year"
                                            :placeholder="$t('ChooseYear')" style="width:150px;">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('MonthlyReference')" style="width:100%">
                            <template>
                                <el-table :data="ElcTable1"
                                          ref="ElcTable1"
                                          border
                                          class="formSTable"
                                          style="width: 100%;">
                                    <el-table-column prop="Jan"
                                                     :label="$t('Jan')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.input1"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Feb"
                                                     :label="$t('Feb')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.input2"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Mar"
                                                     :label="$t('Mar')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.input3"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Apr"
                                                     :label="$t('Apr')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.input4"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="May"
                                                     :label="$t('May')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.input5"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="June"
                                                     :label="$t('Jun')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.input6"></el-input>
                                        </template>
                                    </el-table-column>

                                </el-table>
                                <el-table :data="ElcTable2"
                                          ref="ElcTable2"
                                          border
                                          class="formSTable"
                                          style="width: 100%;">
                                    <el-table-column prop="July"
                                                     :label="$t('Jul')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.input7"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Aug"
                                                     :label="$t('Aug')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.input8"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Sept"
                                                     :label="$t('Sep')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.input9"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Oct"
                                                     :label="$t('Oct')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.input10"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Nov"
                                                     :label="$t('Nov')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.input11"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Dec"
                                                     :label="$t('Dec')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.input12"></el-input>
                                        </template>
                                    </el-table-column>

                                </el-table>
                            </template>

                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="text-align: center ">
                        <el-button type="success" @click="onSubmit">{{ $t('Confirm') }}</el-button>
                        <el-button @click="dialogAddPrice = false">{{ $t('Cancel') }}</el-button>
                    </el-col>
                </el-row>

            </el-form>


        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    export default {
        name: "powerManage",
        data(){
            return{

                area: JSON.parse(sessionStorage.getItem("area")),
                formArea: {cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: ""},
                facList: [],
                building: [],
                labList: [],
                deviveList: [],

                formselect: {
                    DeviceName: "",
                    cityId: "",
                    factoryId: "",
                    buildingId: "",
                    LabId: ""
                },

                dialogAddPrice: false,
                tableData1: [{
                    lab: this.$t('Lab') + 'XXXXXX1212',
                    year: '2020',
                    Jan: '1',
                    Feb: '2',
                    Mar: '3',
                    Apr: '4',
                    May: '5',
                    June: '6',
                    July: '7',
                    Aug: '8',
                    Sept: '9',
                    Oct: '10',
                    Nov: '11',
                    Dev: '12',
                }, {

                }, {


                }],
                Priceform: {
                    country: '',
                    city: '',
                    pack: '',
                    building: '',
                    lab: '',
                    year: '',
                },
                ElcTable1: [{
                    Jan: '',
                    Feb: '',
                    Mar: '',
                    Apr: '',
                    May: '',
                    June: '',
                }],
                ElcTable2: [{
                    July: '',
                    Aug: '',
                    Sept: '',
                    Oct: '',
                    Nov: '',
                    Dev: '',
                }],
                country: [{
                    value: '1',
                    label: '中国'
                }],
                city: [{
                    value: '1',
                    label: '上海'
                }, {
                    value: '2',
                    label: '南京'
                }, {
                    value: '3',
                    label: '杭州'
                }],
                pack: [{
                    value: '1',
                    label: '金桥'
                }, {
                    value: '2',
                    label: '西藏北路'
                }],
                buiilding: [{
                    value: '1',
                    label: this.$t('Experimental')
                }, {
                    value: '2',
                    label: 'B2' + this.$t('ExperimentBuilding')
                }, {
                    value: '3',
                    label: 'B5'+ this.$t('ExperimentBuilding')
                }, {
                    value: '4',
                    label: 'B4'+ this.$t('ExperimentBuilding')
                }],
                lab: [{
                    value: '1',
                    label: 'XXXXXXXXXX' + this.$t('Lab')
                }, {
                    value: '2',
                    label: 'XXXXXXXXXX' + this.$t('Lab')
                }, {
                    value: '3',
                    label: 'XXXXXXXXXX' + this.$t('Lab')
                }, {
                    value: '4',
                    label: 'XXXXXXXXXX' + this.$t('Lab')
                }],

            }
        },
        methods: {
            getFac(e) {
                var a = '', id = e == 'add' ? this.Valueform.cityId : this.formselect.cityId
                this.area.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.facList = this.area[a].children
                this.formselect = {...this.formselect, ...{factoryId: "", buildingId: "", LabId: "", deviceId: ""}}
                this.Valueform = {...this.Valueform, ...{factoryId: "", buildingId: "", LabId: "", deviceId: ""}}
            },
            getBuild(e) {
                var a = '', id = e == 'add' ? this.Valueform.factoryId : this.formselect.factoryId
                this.facList.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.building = this.facList[a].children
                this.formselect = {...this.formselect, ...{buildingId: "", LabId: "", deviceId: ""}}
                this.Valueform = {...this.Valueform, ...{buildingId: "", LabId: "", deviceId: ""}}
            },
            getLab(e) {
                var a = '', id = e == 'add' ? this.Valueform.buildingId : this.formselect.buildingId
                this.building.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.labList = this.building[a].children
                this.formselect = {...this.formselect, ...{LabId: "", deviceId: ""}}
                this.Valueform = {...this.Valueform, ...{LabId: "", deviceId: ""}}
            },
            getDevide(e) {
                var a = '', id = e == 'add' ? this.Valueform.LabId : this.formselect.LabId
                this.labList.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.deviveList = this.labList[a].children
                this.formselect = {...this.formselect, ...{deviceId: ""}}
                this.Valueform = {...this.Valueform, ...{deviceId: ""}}
            },
            openNotice() {
                this.$notify({
                    title: this.$t('warn'),
                    message: this.$t('warningMessage'),
                    type: 'warning'
                });
            },
            togleCollapse() {
                this.isCollapse = !this.isCollapse;
            },
            handleEdit(index, row) {
                //console.log(index, row);
            },
            handleAccredit(index, row) {
                //console.log(index, row);
            },
            handleDelete(index, row) {
                //console.log(index, row);
            },
            onSubmit() {

            },

        },
        computed: mapState({
            isCollapse: state => state.isCollapse
        }),
    }
</script>

<style scoped>

</style>
